//import { IOrderSummarySettings } from './../../components/order-summary/order-summary.component';
import { IOrderSummarySettings } from '../../models/Order/IOrderSummarySettings';
import { AssignTimeWindowsState } from './../../models/TechnicalCoordination/AssignTimeWindowsState.model';
import { TimeWindowsResponse } from './../../models/TechnicalCoordination/TimeWindowsResponse.model';
import { InitCustomerState } from './../../models/InitCustomer/InitCustomerState.model';
import { CampaignState } from './../../models/Campaign/CampaignState.model';
import { IMessageScreenData } from '../../screen-steps/message-screen/message-screen-data.interface';
import { Campaign } from '../../models/Order/Campaign';
import { PaymentResponse } from '../../models/payment/PaymentResponse.model';
import { OrderState } from '../../models/Order/OrderState.model';
/* ON_GET_CONFIG_JSON */
export const ON_INIT_STATE = '[BUNDLE_SALES] [INIT_STATE] ON_INIT_STATE';
export const ON_LOAD_APP_CONFIG_SUCCESS = '[BUNDLE_SALES] [APP_CONFIG] ON_LOAD_APP_CONFIG_SUCCESS';
export const ON_LOAD_APP_CONFIG_FAILED = '[BUNDLE_SALES] [APP_CONFIG] ON_LOAD_APP_CONFIG_FAILED';
export const ON_LOAD_CAMPAIGN_SUCCESS = '[BUNDLE_SALES] [CAMPAIGN] ON_LOAD_CAMPAIGN_SUCCESS';
export const ON_LOAD_CAMPAIGN_FAILED = '[BUNDLE_SALES] [CAMPAIGN] ON_LOAD_CAMPAIGN_FAILED';

export const ON_LOAD_ORDER_SUCCESS = '[BUNDLE_SALES] [ORDER] ON_LOAD_ORDER_SUCCESS';
export const ON_LOAD_ORDER_FAILED = '[BUNDLE_SALES] [ORDER] ON_LOAD_ORDER_FAILED';

export const ON_LOAD_ALTERNATIVE_CAMPAIGN_SUCCESS = '[BUNDLE_SALES] [CAMPAIGN] ON_LOAD_ALTERNATIVE_CAMPAIGN_SUCCESS';
export const ON_LOAD_ALTERNATIVE_CAMPAIGN_FAILED = '[BUNDLE_SALES] [CAMPAIGN] ON_LOAD_ALTERNATIVE_CAMPAIGN_FAILED';
export const ON_SELECT_ALTERNATIVE_CAMPAIGN_SUCCESS = '[BUNDLE_SALES] [CAMPAIGN] ON_SELECT_ALTERNATIVE_CAMPAIGN_SUCCESS';
export const ON_INIT_CUSTOMER_SUCCESS = '[BUNDLE_SALES] [CUSTOMER] ON_INIT_CUSTOMER_SUCCESS';
export const ON_INIT_CUSTOMER_FAILED = '[BUNDLE_SALES] [CUSTOMER] ON_INIT_CUSTOMER_FAILED';
export const ON_ROUTE_TO_MESSAGE_SCREEN = '[BUNDLE_SALES] [ROUTE] ON_ROUTE_TO_MESSAGE_SCREEN';
export const ON_LOAD_TIME_WINDOWS_SUCCESS = '[BUNDLE_SALES] [TECHNICAN_COORDINATION] ON_LOAD_TIME_WINDOWS_SUCCESS';
export const ON_LOAD_TIME_WINDOWS_FAILED = '[BUNDLE_SALES] [TECHNICAN_COORDINATION] ON_LOAD_TIME_WINDOWS_FAILED';
export const ON_ASSIGN_TIME_WINDOW_SUCCESS = '[BUNDLE_SALES] [TECHNICAN_COORDINATION] ON_ASSIGN_TIME_WINDOW_SUCCESS';
export const ON_ASSIGN_TIME_WINDOW_FAILED = '[BUNDLE_SALES] [TECHNICAN_COORDINATION] ON_ASSIGN_TIME_WINDOW_FAILED';

export const ON_LOAD_PAYMENT_RESPONSE='[BUNDLE_SALES] [ROUTE] ON_LOAD_PAYMENT_RESPONSE' ;
export const Show_Order_Open_OR_Close='[BUNDLE_SALES] [ROUTE] Show_Order_Open_OR_Close'
export const ON_ROUTE_TO_SUCCESS_PAGE = '[BUNDLE_SALES] [ROUTE] ON_ROUTE_TO_SUCCESS_PAGE';

export const ON_UPDATE_FLOWBAR_INDEX='[BUNDLE_SALES] [UPDATE_FLOWBA] ON_UPDATE_FLOWBAR_INDEX'
export const ON_UPDATE_ENTRY = '[BUNDLE_SALES] [INIT_STATE] ON_UPDATE_ENTRY';
export const ON_CAMPAIGN_SELECTED = '[BUNDLE_SALES] [INIT_STATE] ON_CAMPAIGN_SELECTED';
// ON_INIT_STATE Campaign selected
export class OnInitState {
  readonly type = ON_INIT_STATE;
  constructor(public payload: any) {}
}

// ON_LOAD_APP_CONFIG
export class OnLoadAppConfigSuccess {
  readonly type = ON_LOAD_APP_CONFIG_SUCCESS;
  constructor(public payload: any) {}
}

// ON_UPDATE_FLOWBAR_INDEX
export class OnUpdateFlowbarIndex {
  readonly type = ON_UPDATE_FLOWBAR_INDEX;
  constructor(public payload: any) {}
}
export class OnLoadAppConfigFailed {
  readonly type = ON_LOAD_APP_CONFIG_FAILED;
  constructor(public payload: any) {}
}

export class OnCampaignSelected {
  readonly type = ON_CAMPAIGN_SELECTED;
  constructor(public payload: Campaign) {}
}
// ON_LOAD_CAMPAIGN
export class OnLoadCampaignSuccess {
  readonly type = ON_LOAD_CAMPAIGN_SUCCESS;
  constructor(public payload: CampaignState) {}
}
export class OnLoadCampaignFailed {
  readonly type = ON_LOAD_CAMPAIGN_FAILED;
  constructor(public payload: CampaignState) {}
}

// ON_LOAD_ALTERNATIVE_CAMPAIGN
export class OnLoadAlternativeCampaignSuccess {
  readonly type = ON_LOAD_ALTERNATIVE_CAMPAIGN_SUCCESS;
  constructor(public payload: CampaignState) {}
}
export class OnLoadAlternativeCampaignFailed {
  readonly type = ON_LOAD_ALTERNATIVE_CAMPAIGN_FAILED;
  constructor(public payload: CampaignState) {}
}
export class OnSelectAlternativeCampaignSuccess {
  readonly type = ON_SELECT_ALTERNATIVE_CAMPAIGN_SUCCESS;
  constructor(public payload: CampaignState) {}
}


// ON_INIT_CUSTOMER
export class OnInitCustomerSuccess {
  readonly type = ON_INIT_CUSTOMER_SUCCESS;
  constructor(public payload: InitCustomerState) {}
}
export class OnInitCustomerFailed {
  readonly type = ON_INIT_CUSTOMER_FAILED;
  constructor(public payload: InitCustomerState) {}
}
//ON_LOAD_PAYMENT_RESPONSE_SUCCESS
export class OnLoadPaymentResponseSuccess{
  readonly type= ON_LOAD_PAYMENT_RESPONSE;
  constructor(public payload:PaymentResponse){}
}

// ON_LOAD_TIME_WINDOWS
export class OnLoadTimeWindowsSuccess {
  readonly type = ON_LOAD_TIME_WINDOWS_SUCCESS;
  constructor(public payload: TimeWindowsResponse) {}
}
export class OnLoadTimeWindowsFailed {
  readonly type = ON_LOAD_TIME_WINDOWS_FAILED;
  constructor(public payload: TimeWindowsResponse) {}
}

// ON_ASSIGN_TIME_WINDOW
export class OnAssignTimeWindowSuccess {
  readonly type = ON_ASSIGN_TIME_WINDOW_SUCCESS;
  constructor(public payload: AssignTimeWindowsState) {}
}
export class OnAssignTimeWindowFailed {
  readonly type = ON_ASSIGN_TIME_WINDOW_FAILED;
  constructor(public payload: AssignTimeWindowsState) {}
}


// ROUTE_TO_MESSAGE_SCREEN
export class OnRouteToMessageScreen {
  readonly type = ON_ROUTE_TO_MESSAGE_SCREEN;
  constructor(public payload: IMessageScreenData) {}
}

// ON_ROUTE_TO_SUCCESS_PAGE
export class OnRouteToSuccessPage {
  readonly type = ON_ROUTE_TO_SUCCESS_PAGE;
  constructor(public payload: IOrderSummarySettings) {}
}
// ON_ROUTE_TO_Payment_Details
export class ShowOrderOpenORClose {
  readonly type = Show_Order_Open_OR_Close;
  constructor(public payload:boolean) {}
}
export class OnUpdateEntry {
  readonly type = ON_UPDATE_ENTRY;
  constructor(public payload: any) {}
}
export class OnLoadOrderSuccess{
  readonly type =ON_LOAD_ORDER_SUCCESS;
  constructor(public payload:OrderState){}
}
export class OnLoadOrderFaild{
  readonly type =ON_LOAD_ORDER_FAILED;
  constructor(public payload:OrderState){}
}
export type Action =
OnInitState |
OnLoadAppConfigSuccess | OnLoadAppConfigFailed |
OnLoadCampaignSuccess | OnLoadCampaignFailed |
OnLoadAlternativeCampaignSuccess | OnLoadAlternativeCampaignFailed |
OnSelectAlternativeCampaignSuccess |
OnInitCustomerSuccess | OnInitCustomerFailed |
OnLoadTimeWindowsSuccess | OnLoadTimeWindowsFailed |
OnAssignTimeWindowSuccess | OnAssignTimeWindowFailed |
OnRouteToMessageScreen |OnLoadPaymentResponseSuccess|
OnRouteToSuccessPage | ShowOrderOpenORClose|
OnLoadOrderSuccess|OnLoadOrderFaild|OnCampaignSelected |
OnUpdateEntry|OnUpdateFlowbarIndex
;
